import React from 'react';

const VIDEO_EXT = /\.(mp4|webm|mov|m4v)(\?|$)/i;

export const isVideoSrc = (src) => typeof src === 'string' && VIDEO_EXT.test(src);

const MediaElement = React.forwardRef(function MediaElement(
  { src, alt = '', className = '', loading = 'lazy', ...rest },
  ref
) {
  if (isVideoSrc(src)) {
    return (
      <video
        ref={ref}
        src={src}
        className={className}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        {...rest}
      />
    );
  }
  return (
    <img
      ref={ref}
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      {...rest}
    />
  );
});

export default MediaElement;
